import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CONTACT_EMAIL, CONTACT_PHONE } from "@/lib/brand";

const LAST_UPDATED = "17 July 2026";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <Header onCTA={() => (window.location.href = "/#contact")} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 prose prose-slate">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">Legal</div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-slate-900 mb-2">Privacy Policy</h1>
        <p className="text-sm text-slate-500 mb-10">Last updated: {LAST_UPDATED}</p>

        <Section title="1. Who we are">
          Loan81 ("Loan81", "we", "us", "our") operates loan81.com and connects individuals looking for
          personal loans with partner banks and Non-Banking Financial Companies (NBFCs) as a loan referral
          and comparison platform. We are not a bank, NBFC, or lender, and we do not sanction or disburse
          loans ourselves.
        </Section>

        <Section title="2. What information we collect">
          When you submit an enquiry on Loan81, we collect the information you provide directly, which may
          include your name, phone number, email address, loan amount required, preferred tenure, preferred
          lender, and any additional message you choose to share. We also automatically collect basic
          technical information (such as IP address and browser type) for security and fraud-prevention
          purposes.
        </Section>

        <Section title="3. Why we collect it">
          We use your information to: (a) match you with suitable loan offers from our partner banks/NBFCs,
          (b) have our loan advisors or a partner lender contact you regarding your enquiry, (c) improve our
          comparison tool and website, and (d) comply with applicable law. We do not use your financial
          information for any purpose beyond facilitating your loan enquiry.
        </Section>

        <Section title="4. Who we share it with">
          We share your enquiry details only with the specific bank(s)/NBFC(s) relevant to your enquiry — for
          example, the lender you selected, or lenders whose eligibility criteria your enquiry matches — so
          that they may contact you with an offer. We do not sell your personal data to data brokers or
          unrelated third parties. We may also share information where required by law, regulation, or a
          valid legal process.
        </Section>

        <Section title="5. Your consent to being contacted">
          By submitting the enquiry form, you consent to being contacted by Loan81 and/or the relevant
          partner bank(s)/NBFC(s) via phone call, SMS, WhatsApp, or email regarding your loan enquiry, even
          if your number is registered under the National Do Not Disturb (DND) / NCPR registry, to the extent
          permitted by applicable regulations for transactional/service communication you have requested.
        </Section>

        <Section title="6. Data retention">
          We retain your enquiry data for as long as reasonably necessary to fulfil the purpose it was
          collected for, and thereafter as required to meet legal, accounting, or reporting obligations.
        </Section>

        <Section title="7. Your rights">
          You may write to us to request access to, correction of, or deletion of your personal data, or to
          withdraw your consent to be contacted, subject to applicable law. We will act on verified requests
          within a reasonable time.
        </Section>

        <Section title="8. Security">
          We use reasonable technical and organisational measures — including encrypted connections and
          access-controlled admin systems — to protect your data. No method of transmission or storage is
          completely secure, and we cannot guarantee absolute security.
        </Section>

        <Section title="9. Changes to this policy">
          We may update this Privacy Policy from time to time. The "Last updated" date at the top reflects
          the most recent revision. Continued use of Loan81 after changes constitutes acceptance of the
          revised policy.
        </Section>

        <Section title="10. Contact us">
          For any privacy-related questions or requests, write to us at{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-emerald-600 font-medium">{CONTACT_EMAIL}</a>{" "}
          or call {CONTACT_PHONE}.
        </Section>
      </div>
      <Footer />
    </div>
  );
}

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-lg font-semibold text-slate-900 mb-2">{title}</h2>
    <p className="text-slate-600 leading-relaxed text-[15px]">{children}</p>
  </div>
);
